import type { SVGProps } from 'react';

const SvgHamburgerBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M4 6H20' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M4 12H20' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M4 18H20' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgHamburgerBd;
